function arraySome(array, predicate) {
  for (var index = -1, length = array == null ? 0 : array.length; ++index < length; )
    if (predicate(array[index], index, array))
      return !0;
  return !1;
}
export {
  arraySome as default
};
//# sourceMappingURL=_arraySome.js.map
